import type { SVGProps } from "react";
const SvgHome05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M10 14.167h.008"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.25}
      d="M16.667 7.083v4.167c0 3.143 0 4.714-.977 5.69-.976.977-2.547.977-5.69.977s-4.714 0-5.69-.977c-.977-.976-.977-2.547-.977-5.69V7.083"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.25}
      d="m18.333 8.75-3.619-3.47C12.492 3.149 11.381 2.083 10 2.083c-1.38 0-2.492 1.066-4.714 3.197l-3.62 3.47"
    />
  </svg>
);
export default SvgHome05;
